export default __webpack_public_path__ + "5a509df5c76aeab4893bb122eae338e9.png";